var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94797 8.52441C6.59779 8.52441 6.31392 8.24054 6.31392 7.89036L6.31392 4.73909C6.31392 4.3889 6.59779 4.10503 6.94797 4.10503C7.29815 4.10503 7.58203 4.38891 7.58203 4.73909L7.58203 7.89036C7.58203 8.24054 7.29815 8.52441 6.94797 8.52441Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 12.9438C10.1656 12.9438 12.7319 10.3775 12.7319 7.2119C12.7319 4.04627 10.1657 1.48003 7.00002 1.48003C3.83439 1.48003 1.26812 4.04627 1.26812 7.2119C1.26812 10.3775 3.83439 12.9438 7.00002 12.9438ZM14 7.2119C14 11.0779 10.866 14.2119 7.00002 14.2119C3.13403 14.2119 2.73984e-07 11.0779 6.1196e-07 7.2119C9.49937e-07 3.3459 3.13404 0.211913 7.00002 0.211913C10.866 0.211914 14 3.34591 14 7.2119Z",
    fill: "#0F20E8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.94792,
    cy: 9.81901,
    rx: 0.583333,
    ry: 0.583333,
    transform: "rotate(-180 6.94792 9.81901)",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWarning);
export default __webpack_public_path__ + "static/media/info_warning.0c8881794970af9ac32a21e2f9fc298c.svg";
export { ForwardRef as ReactComponent };